import { render } from "./Professional.vue?vue&type=template&id=738ac5b8"
import script from "./Professional.vue?vue&type=script&lang=js"
export * from "./Professional.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__